import { URL_LABEL } from "../../../index.content";

const stepByStepCourses = ({ language, isSavedUser }) => {
  return {
    title: "Step-by-Step Courses",
    url: isSavedUser
      ? `/app/#/course?${URL_LABEL}`
      : `/amazon-private-label-course?${URL_LABEL}`,
    target: false,
    ref: false,
    isLink: !isSavedUser,
  };
};

export default stepByStepCourses;
